/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type UnansweredCommentsTabCommentContainer_story = {
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainer1_story" | "CommentContainer_story">;
    readonly " $refType": "UnansweredCommentsTabCommentContainer_story";
};
export type UnansweredCommentsTabCommentContainer_story$data = UnansweredCommentsTabCommentContainer_story;
export type UnansweredCommentsTabCommentContainer_story$key = {
    readonly " $data"?: UnansweredCommentsTabCommentContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"UnansweredCommentsTabCommentContainer_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UnansweredCommentsTabCommentContainer_story",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListContainer1_story"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_story"
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = 'b18f145278574847de36d264f1738749';
export default node;
